import { ROUTES } from "../routes/Routes";

type MenuItem = {
  key?: string;
  label: string;
  path: string;
  icon?: string;
  children?: MenuItem[];
};

export const mainMenuItems: MenuItem[] = [
  { key: "order_management", path: ROUTES.ORDER_MANAGEMENT.path, label: "Order Management" },
  { key: "category_management", path: ROUTES.CATEGORY_MANAGEMENT.path, label: "Category Management" },
  { key: "store_management", path: ROUTES.STORE_MANAGEMENT.path, label: "Store Management" },
  { key: "ingredient_management", path: ROUTES.INGREDIENT_MANAGEMENT.path, label: "Ingredient Management" },
  { key: "product_management", path: ROUTES.PRODUCT_MANAGEMENT.path.replace('/:storeId?', ''), label: "Product Management" },
  { key: "finance_management", path: ROUTES.FINANCE_MANAGEMENT.path, label: "Finance Management" },
];

